import { createTheme } from '@mui/material/styles';

// Shared surface treatment keeps all CAD colors readable without changing alert colors.
export function operationalTheme(base) {
  return createTheme(base, {
    shape: { borderRadius: 10 },
    components: {
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none', borderRadius: 12, borderWidth: 1, boxShadow: 'none' } } },
      MuiAppBar: { styleOverrides: { root: { borderRadius: 0 } } },
      MuiCard: { styleOverrides: { root: { borderWidth: 1, borderRadius: 12, boxShadow: 'none' } } },
      MuiButton: { styleOverrides: { root: { minHeight: 44, borderRadius: 8, borderWidth: 1, letterSpacing: '0.01em', fontWeight: 700, textTransform: 'none', boxShadow: 'none', '&:hover': { boxShadow: 'none' } } } },
      MuiIconButton: { styleOverrides: { root: { minWidth: 44, minHeight: 44 } } },
      MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8 } } },
      MuiDialog: { styleOverrides: { paper: { borderRadius: 16 } } },
      MuiTableCell: { styleOverrides: { root: { fontVariantNumeric: 'tabular-nums' } } },
    },
  });
}
